import { ThemeProvider } from "next-themes";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Footer, Header } from "@/components/Layout";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Equipe from "@/pages/Equipe";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminBlogForm from "@/pages/AdminBlogForm";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <HelmetProvider>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <ReactLenis root options={{ lerp: 0.08, duration: 1.15, smoothWheel: true }}>
        <div className="App site-shell">
          <BrowserRouter>
            <ScrollToTop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/a-propos" element={<About />} />
                <Route path="/equipe" element={<Equipe />} />
                <Route path="/actualites" element={<Blog />} />
                <Route path="/actualites/:slug" element={<BlogPost />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin/blog/:id" element={<AdminBlogForm />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
          <Toaster richColors position="top-center" />
        </div>
      </ReactLenis>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
